module.exports = __webpack_public_path__ + "img/Boutique.b97f0011.jpg";